/* unplugin-vue-components disabled */import { render } from "./files-uploader.vue?vue&type=template&id=36e77336&scoped=true"
import script from "./files-uploader.vue?vue&type=script&lang=js"
export * from "./files-uploader.vue?vue&type=script&lang=js"

import "./files-uploader.vue?vue&type=style&index=0&id=36e77336&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e77336"],['__file',"src/components/uploader/files-uploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36e77336"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36e77336', __exports__)) {
    api.reload('36e77336', __exports__)
  }
  
  module.hot.accept("./files-uploader.vue?vue&type=template&id=36e77336&scoped=true", () => {
    api.rerender('36e77336', render)
  })

}


export default __exports__